// extracted by mini-css-extract-plugin
module.exports = {"frame":"KnowledgeBaseCourseManager_frame__o9C8a"};